import { React, useState, useEffect, createContext, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import request from "../../../../Helpers/API";
import { Autocomplete, Button, Modal, Box, TextField, MenuItem, InputAdornment } from "@mui/material";
import { GetKey, GetText } from "../../../../Helpers/GetKey";
import { ValOnlyNumber } from "../../../../Validators/ValOnlyNumber";
import { Moneda } from "../../../../Helpers/Moneda";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../../components/LoaderScreen";
import { FormatMoney } from "../../../../Helpers/FormatNumber";

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { FeaturedPlayList } from "@mui/icons-material";
import PercentIcon from '@mui/icons-material/Percent';
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import MedioContactoModal from "./MedioContactoModal";

const RegistrarComentarioModal = ({ open, onClose, onRegresar, facturasSeleccionadas, saldo, moratorios, interespactado, total, mediocontacto, gestion, objecion, responsable, idcliente }) => {
    const [tipo, setTipo] = useState("");
    const [contacto, setContacto] = useState({ medio: null });
    const [responsablesCobranza, setResponsablesCobranza] = useState([]);
    const { state } = useLocation();
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const [info, setInfo] = useState({
        info: {},
        revolvente: {},
        operacion: {},
    });

    const handleRegresar = () => {
        onClose(); // Cierra el modal de registrar comentario
        onRegresar(); // Abre el modal de medio de contacto
      };
    

    const [comentarios, setComentarios] = useState({
        monto: 0,
        fechaconvenio: "",
        volvercontactar: false,
        fechanvolveracontactar: "",
        mediocontacto: "T",
        descuento: 0,
        razon_descuento: "",
        responsable: "",
        idresponsable: responsable,
        ADR: 0,
        firma: "",
        bmonto: false,
        comentarios: ""
    });

    const [calculoFacturas, setCalculoFacturas] = useState({
        saldo: 0,
        pactados: 0,
        moratorios: 0,
        total: 0
    });

    const onChange = (prop, value, sbool, smensaje) => {
        const sinComas = value.replace(/,/g, "");
        setComentarios({
            ...comentarios,
            [prop]: sinComas,
            ["b" + prop]: false,
            ["m" + prop]: "",
        });
    };


    useEffect(() => {
        request
            .get("GenerarConvenioModal/DropDownListResponsables")
            .then((result) => {
                setResponsablesCobranza(result);
                if (responsable) {
                    const selectedResponsable = result.find(
                        (cob) => cob.idusuario === responsable
                    );
                    if (selectedResponsable) {
                        setComentarios((prevComentarios) => ({
                            ...prevComentarios,
                            idresponsable: selectedResponsable.idusuario,
                            responsable: selectedResponsable.responsable_cobranza,
                            ADR: selectedResponsable.adr,
                        }));
                    }
                }

            })
            .catch((error) => {
                console.error("Error al cargar responsables:", error);
            });
    }, [responsable]);

    const guardarGestion = () => {
        if (facturasSeleccionadas.length === 0) {
            Swal.fire({
                title: "GESTION DE COBRANZA",
                text: "Debes seleccionar al menos una factura.",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return; // Detiene la ejecución si no hay facturas seleccionadas
        }
        if (comentarios.responsable === 0 || comentarios.responsable === null || comentarios.responsable === "") {
            Swal.fire({
                title: "GESTION DE COBRANZA",
                text: "Selecciona un responsable.",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return; // Detiene la ejecución si no hay facturas seleccionadas
        }

        setLoader({ ...loader, mostrar: true });
        const post = {
            folio: "*************",
            idcliente: state.idcliente,
            razon_social: info.info.razon_social,
            referencia: info.info.referencia,
            adr: comentarios.ADR,
            monto: comentarios.monto,
            tipo_credito: tipo,
            fecha_convenio: "",
            recordatorio: false,
            fecha_recordatorio: "",
            mediocontacto: mediocontacto,
            nombre_usuario: comentarios.responsable.toUpperCase(),
            idresponsable: comentarios.idresponsable,
            firma: comentarios.firma,
            descuento: comentarios.descuento,
            razon_descuento: comentarios.razon_descuento,
            detalle: JSON.stringify(facturasSeleccionadas),
            gestion: gestion,
            objecion: objecion,
            comentarios: comentarios.comentarios,
            volvercontactar: comentarios.volvercontactar,
            fechavolveracontactar: comentarios.fechanvolveracontactar,
            saldo: saldo,
            moratorios: moratorios,
            interespactado: interespactado,
            total: total
        };
        const postresponsable = {
            idcliente: idcliente,
            idusuario: comentarios.idresponsable
        };
        request
            .post(`GuardarGestionCobranzaComentarios/Guardar`, post)
            .then(async (result) => {
                return request.post(`ClientesResponsableCobranza/Guardar`, postresponsable);
            })
            .then(async (result) => {
                setLoader({ ...loader, mostrar: false });
                onClose();
                await Swal.fire({
                    title: "GESTION DE COBRANZA",
                    text: "Registro guardado con éxito",
                    icon: "success",
                    customClass: {
                        container: "mi-superpoop",
                    },
                });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("GESTION DE COBRANZA", JSON.stringify(error), "error");
            });
    };

    useEffect(() => {
        if (mediocontacto) {  
            setLoader({ ...loader, mostrar: true });
            request
                .get(`MostarContactoCliente/ContactoCliente?idcliente=${idcliente}&medio=${mediocontacto}`)
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    if (Array.isArray(result) && result.length > 0) {
                        setContacto(result[0]); 
                    } else {
                        setContacto({ medio: "No tiene el medio seleccionado registrado" });
                    }
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire("CONVENIO PAGO", JSON.stringify(error), "error");
                });
        }
    }, [mediocontacto]);

    return (
        <>
            <Modal open={open} onClose={onClose} closeAfterTransition
                BackdropProps={{
                    timeout: 300,
                }} disableRestoreFocus={true}>
                <div className="generar-convenio-modal-formulario">
                    <div className="generar-convenio-modal-plantilla">
                        <div className="plantilla-screen-filtro-container" id="mdlFiltros-modal">
                            <PlantillaScreen
                                titulo={state.razonsocial}
                                className_main={1}
                                className={"plantilla-screen-filtro-container-modal"}
                            >
                                <div className="cerrar-modal-button" onClick={onClose}>X</div>
                                <div className={`generar-convenio-modal-agregar-convenio`}>
                                    <div className="generar-convenio-modal-agregar-convenio-container scroll-4">
                                        <h3 className="titulo-seccion">Registrar Comentario</h3>
                                        <TextField
                                                id="contacto"
                                                size="small"
                                                label="Contacto"
                                                variant="outlined"
                                                type="text"
                                                inputProps={{
                                                    style: { textAlign: "left" },
                                                    readOnly: true, 
                                                }}
                                                value={contacto.medio || ""}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start"></InputAdornment>
                                                    ),
                                                }}
                                                sx={{ mt: 2 }}
                                            />
                                        <TextField
                                            id="outlined-multiline-static"
                                            label="Comentario"
                                            sx={{ mt: 2 }}
                                            value={comentarios.comentarios}
                                            onChange={(e) => {
                                                setComentarios({
                                                    ...comentarios,
                                                    comentarios: e.target.value,
                                                });
                                            }}
                                        />
                                        <TextField
                                            className="input-medio-comunicacion"
                                            fullWidth
                                            size="small"
                                            label="Responsable"
                                            select
                                            type="text"
                                            // Asegúrate de que value esté correctamente asignado al idresponsable del estado comentarios
                                            value={comentarios.idresponsable || ""}
                                            onChange={(e) => {
                                                const selectedResponsable = responsablesCobranza.find(
                                                    (cob) => cob.idusuario === e.target.value
                                                );
                                                // Actualiza correctamente el estado comentarios con el responsable seleccionado
                                                setComentarios({
                                                    ...comentarios,
                                                    responsable: selectedResponsable?.responsable_cobranza || "",
                                                    ADR: selectedResponsable?.adr || 0,
                                                    idresponsable: selectedResponsable?.idusuario || 0,
                                                });
                                            }}
                                            sx={{ mt: 2 }}
                                        >
                                            {responsablesCobranza.map((cob) => (
                                                <MenuItem key={cob.idusuario} value={cob.idusuario}>
                                                    {cob.responsable_cobranza}
                                                </MenuItem>
                                            ))}
                                        </TextField>

                                        {comentarios.mediocontacto !== "DO" && (
                                            <div className="generar-convenio-modal-agregar-datos-columna-2">
                                                <div className="generar-convenio-modal-agregar-recordatorio">
                                                    <input
                                                        type="checkbox"
                                                        name="convenio"
                                                        className="chk-groups"
                                                        id="convenio"
                                                        checked={comentarios.volvercontactar}
                                                        onChange={(e) => {
                                                            setComentarios({
                                                                ...comentarios,
                                                                volvercontactar: e.target.checked,
                                                            });
                                                        }}
                                                    />
                                                    <span>Volver a contactar</span>
                                                </div>
                                                {comentarios.volvercontactar && (
                                                    <div>
                                                        <TextField
                                                            disabled={!comentarios.volvercontactar}
                                                            size="small"
                                                            type="date"
                                                            fullWidth
                                                            onChange={(e) => {
                                                                setComentarios({
                                                                    ...comentarios,
                                                                    fechanvolveracontactar: e.target.value,
                                                                });
                                                            }}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                    <div className="generar-convenio-modal-buttons">
                                        {/* <div
                                            className="detalle-clientes-gestionar-footer-back"
                                            onClick={handleRegresar}
                                        >
                                            <ArrowBackIcon /> Regresar
                                        </div> */}
                                        <button
                                            className="generar-convenio-modal-button-guardar"
                                            onClick={() => guardarGestion()}
                                        >
                                            Guardar
                                        </button>
                                    </div>
                                </div>
                            </PlantillaScreen>
                        </div>

                    </div>
                </div>
            </Modal >
        </>
    );
};

export default RegistrarComentarioModal;